import { render, staticRenderFns } from "./InfoApprovalSigns.vue?vue&type=template&id=0b464620&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b464620')) {
      api.createRecord('0b464620', component.options)
    } else {
      api.reload('0b464620', component.options)
    }
    module.hot.accept("./InfoApprovalSigns.vue?vue&type=template&id=0b464620&", function () {
      api.rerender('0b464620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/components/InfoApprovalSigns.vue"
export default component.exports